import { ImpulseElement, registerElement, target } from '@ambiki/impulse';

@registerElement('pay-rate-field')
export default class PayRateFieldElement extends ImpulseElement {
  @target() teammateContainer: HTMLElement;
  @target() teammateSelectField: HTMLSelectElement;

  toggleTeammateVisibility(event: Event) {
    const radio = event.target;
    if (!(radio instanceof HTMLInputElement)) return;

    // Make the teammate select visible and mark it as a `required` field.
    const userRate = radio.value === 'user';
    this.teammateContainer.hidden = !userRate;
    this.teammateSelectField.required = userRate;
  }
}
